import styled from "styled-components";

/**
 * Базовый layout для полноэкранных страниц со shared Table.
 *
 * Заголовки, breadcrumbs, метрики и toolbar занимают естественную высоту,
 * а Table как flex-ребёнок получает всё оставшееся место карточки.
 * Это избавляет страницы от собственных calc/remHeight-подгонок.
 */
export const TablePageContent = styled.div`
  min-width: 0;
  min-height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;
